export default function createMapWithKeys<T>(keys: string[], value: T): { [key: string]: T } {
    const obj: { [key: string]: T } = {};

    for (const key of keys) {
        obj[key] = value;
    }

    return obj;
}
